/**
 * Initialise les tooltips Bootstrap.
 */
export const initializeTooltips = () => {
    $('[data-toggle="tooltip"]').tooltip();

    $('[data-toggle="tooltip"]').each((index, element) => {
        $(element).on("click", () => {
            $(element).tooltip("hide");
        });
    });
};
